






































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import IBarcode from '@/components/icons/IBarcode.vue'
import IEdit from '@/components/icons/IEdit.vue'
import ITrash from '@/components/icons/ITrash.vue'
import IShard from '@/components/icons/IShard.vue'
import IQR from '@/components/icons/IQR.vue'
import TableIcon from '@/components/icons/TableIcon.vue'
import IArrow from '@/components/icons/IArrow.vue'
import Tooltip from '@/components/UI/Tooltip.vue';

@Component({
    name: "table-component",
    components: {
        'i-barcode': IBarcode,
        'i-edit': IEdit,
        'i-trash': ITrash,
        'i-shard': IShard,
        'i-qr': IQR,
        'i-arrow': IArrow,
        TableIcon,
        Tooltip
    }
})

export default class TableComponent extends Vue {

    @Prop({type: Array, default: () => [],}) items !:any
    @Prop({type: Array, default: () => [],}) headers !:any
    @Prop({type: Array, default: () => [],}) headersMinTable !:any
    @Prop({type: String, default: '36px'}) protected height!: string
    @Prop({type: String, default: null}) protected noDataText!: string
    @Prop({type: String, default: '#0A0A0A'}) protected iconColor!: string
    @Prop({type: Number, default: 10}) protected itemsPerPage!: number
    @Prop({type: Boolean, default: false}) loading !:any
    @Prop({type: Boolean, default: false}) isMinTable !:any
    @Prop({type: Boolean, default: false}) isClickRow !:any

    get currentHeaders() {
        return this.isMinTable ? this.headersMinTable : this.headers
    }

    openBarcode(item:any) {
        this.$emit('openBarcode', item)
    }

    click(item:any, action:string) {
        this.$emit('click', item, action)
    }

    clickRow(item:any) {
        if(this.isClickRow) this.$emit('clickRow', item)
    }

    setFullTable() {
        this.$emit('setFullTable')
    }

    timeConverter(UNIX_timestamp: any) {
        const a = new Date(UNIX_timestamp * 1000);
        const months = ['янв', 'фев', 'март', 'апр', 'май', 'июнь', 'июль', 'авг', 'сен', 'окт', 'ноя', 'дек'];
        const year = a.getFullYear();
        const month = this.dable(a.getMonth() + 1);
        const date = this.dable(a.getDate());
        const clock = this.dable(a.getHours())
        const min = this.dable(a.getMinutes())
        const rTime = clock + ':' + min
        const rDate = date + '.' + month + '.' + year;

        return {rDate, rTime};
    }
    dable(num: number) {
        return num < 10 ? '0' + num : num
    }

}
